import React, { useEffect, useState } from "react";
import "./PlaceholderPage.css";
import { MDBBtn, MDBBadge } from "mdb-react-ui-kit";

const EbayIntegrationPage = ({ company_id }) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      const companyId = localStorage.getItem("company_id");
      const res = await fetch(
        `https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/getEbayStoreByCompany/${companyId}`
      );

      const data = await res.json();

      if (data.success) {
        setStores(data.data);
      } else {
        setStores([]);
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEbayIntegrate = async (e) => {
    e.stopPropagation();

    try {
      const res = await fetch(
        "https://crosslisting-backend-aacranbzdyd3ffbd.centralindia-01.azurewebsites.net/api/v1/ebayUrlFB",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      console.error("eBay integrate error:", err);
    }
  };

  return (
    <div className="placeholder-page">
      <div className="ebay-header">
        <div>
          <h1 className="page-title">eBay Integration</h1>
          <p className="integration-subtitle">
            Connected eBay accounts
          </p>
        </div>

        <MDBBtn
          color="primary"
          className="integrate-btn"
          onClick={handleEbayIntegrate}
        >
          + Integrate New Store
        </MDBBtn>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : stores.length === 0 ? (
        <div className="empty-state">
          <h5>No eBay account connected</h5>
          <p>Integrate your first eBay store.</p>
        </div>
      ) : (
        <div className="store-grid">
          {stores.map((store, index) => (
            <div className="store-card" key={index}>
              <div className="store-top">
                <img
                  src={
                    store.imageurl ||
                    "https://upload.wikimedia.org/wikipedia/commons/1/1b/EBay_logo.svg"
                  }
                  alt={store.storeName}
                  className="store-logo"
                />

                <MDBBadge color="success">Connected</MDBBadge>
              </div>

              <h5 className="store-name">
                {store.storeName}
              </h5>

              <div className="store-marketplace">
                Marketplace: {store.marketplace}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EbayIntegrationPage;